// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c2e5c70","239":"16594125","453":"fb00b2d6","732":"15e1431e"}[chunkId] + ".chunk.js";
};